/**
 * Per-council risk-indicator visibility for the embedded DAISY chatbot.
 *
 * Mirrors the DAISY app's `features.riskIndicators` tenant config, but expressed
 * as plain constants (this widget has no shared config system). A hazard set to
 * `false` is treated as "not part of this council": it is dropped from the
 * chatbot restriction message (the widget has no separate visual indicator).
 *
 * Keyed by lowercase council slug; matched case-insensitively (substring) against
 * the council name from `_getOriginalCouncil()`.
 * Omit a council (or a hazard) to keep it enabled.
 */
export const RISK_INDICATORS_BY_COUNCIL = {
    cumberland: { flood: false },
    wingecarribee: { flood: false },
    // blacktown / muswellbrook / newcastle: omitted ⇒ all shown
};

/** Default when a council (or a specific hazard) has no override. */
const DEFAULT_RISK_INDICATORS = { bushfire: true, flood: true, heritage: true };

/**
 * Resolves which risk indicators are enabled for a council.
 *
 * @param {string} [councilName] - Council name or slug (any casing). Falsy/unknown
 *   ⇒ all enabled.
 * @returns {{ bushfire: boolean, flood: boolean, heritage: boolean }}
 */
export function getEnabledRiskIndicators(councilName) {
    const key = (councilName || '').trim().toLowerCase();
    const slug = Object.keys(RISK_INDICATORS_BY_COUNCIL).find((c) => key.includes(c));
    return {
        ...DEFAULT_RISK_INDICATORS,
        ...(slug ? RISK_INDICATORS_BY_COUNCIL[slug] : {}),
    };
}
